import { VALID_MIMETYPES } from "fleet/constant/media-library";
import PropTypes from "prop-types";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { NativeTypes } from "react-dnd-html5-backend";
import FileDropBox from "ui/file-drop-box";
import dragDropContext from "util/drag-drop-context";

import { MediaUploadFileForm } from "./media-upload-file-form";
import { isValidMimeType } from "./utils";

class MediaUploadForm extends React.Component {
  static get displayName() {
    return "MediaUploadForm";
  }

  static get propTypes() {
    return {
      upload: PropTypes.func.isRequired,
      hasUploadError: PropTypes.bool,
      isUploading: PropTypes.bool,
      onError: PropTypes.func,
    };
  }

  static get defaultProps() {
    return {
      hasUploadError: false,
      isUploading: false,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      currentUpload: null,
      pendingFiles: {},
    };

    this.onFileDrop = this.onFileDrop.bind(this);
    this.onFileBrowse = this.onFileBrowse.bind(this);
    this.onRemoveContent = this.onRemoveContent.bind(this);
    this.onUpdateFile = this.onUpdateFile.bind(this);
    this.onUploadContent = this.onUploadContent.bind(this);
  }

  componentDidUpdate(pProps) {
    if (pProps.isUploading && !this.props.isUploading) {
      const { currentUpload, pendingFiles } = this.state;

      if (!this.props.hasUploadError) {
        delete pendingFiles[currentUpload];
      }

      this.setState({ pendingFiles, currentUpload: null });
    }
  }

  onFileDrop(_item, monitor) {
    if (!monitor) {
      return null;
    }

    this._addFilesToPending(monitor.getItem().files);
  }

  onFileBrowse(e) {
    this._addFilesToPending(e.currentTarget.files);
  }

  _addFilesToPending(files) {
    const { pendingFiles } = this.state;

    const hasInvalidMimetype = [];
    const filesToAdd = {};
    for (let f = 0; f < files.length; f++) {
      const file = files[f];
      if (isValidMimeType(file.type)) {
        filesToAdd[file.name] = {
          fname: file.name,
          rawFile: file,
          name: "",
          duration: 15,
        };
      } else {
        hasInvalidMimetype.push(file.name);
      }
    }

    if (hasInvalidMimetype.length) {
      this.props.onError(
        `${hasInvalidMimetype.join(", ")} had invalid mimetypes. ` +
          `Mimetypes should be one of ${VALID_MIMETYPES.join(", ")}`,
      );
    }

    this.setState({
      pendingFiles: {
        ...pendingFiles,
        ...filesToAdd,
      },
    });
  }

  onRemoveContent(fname) {
    const { pendingFiles } = this.state;
    delete pendingFiles[fname];
    this.setState({ pendingFiles });
  }

  onUploadContent(file) {
    const durationMs = parseInt(file.duration, 10) * 1000;
    this.setState({ currentUpload: file.fname }, () => {
      this.props.upload({
        duration: durationMs,
        file: file.rawFile,
        filename: file.fname,
        name: file.name,
      });
    });
  }

  onUpdateFile(file, field, value) {
    const { fname } = file;
    const { pendingFiles } = this.state;
    const updatedFile = {
      ...pendingFiles[fname],
      ...{ [field]: value },
    };
    this.setState({
      pendingFiles: {
        ...pendingFiles,
        ...{ [fname]: updatedFile },
      },
    });
  }

  _renderFileForm(file) {
    const { isUploading } = this.props;
    return (
      <MediaUploadFileForm
        key={file.fname}
        disabled={isUploading}
        file={file}
        onUpdate={this.onUpdateFile}
        onRemove={this.onRemoveContent}
        onUpload={this.onUploadContent}
      />
    );
  }

  render() {
    const { FILE } = NativeTypes;
    const { pendingFiles } = this.state;
    return (
      <Row className="content-upload-form">
        <Col xs={4}>
          <FileDropBox
            accepts={[FILE]}
            onDrop={this.onFileDrop}
            onBrowse={this.onFileBrowse}
          />
        </Col>
        <Col xs={8} className="content-upload-form-files">
          {Object.values(pendingFiles).map((pf) => this._renderFileForm(pf))}
        </Col>
      </Row>
    );
  }
}

const MediaDragDropUploadForm = dragDropContext(MediaUploadForm);
export { MediaDragDropUploadForm, MediaUploadForm };
